import { apolloClientCC as apolloClient } from "../../../vue-apollo";
import { exQue, exMut } from "@/utils/gql";
// src/store/modules/tv/storeTV.js
import {
  GET_CANALES,
  GET_ESTADO_CANALES,
  GET_LIST_SCREENS,
  GET_SCREEN,
  GET_TIMEZONES,
  GET_SCREENS_REGISTERED,
  GET_PANTALLAS_PAGINADAS,
  GET_TOTAL_PANTALLAS_ONOFF,
  GET_PALETA_COLORES,
  GET_LOG_TVS_PAGINATION,
  GET_LOG_TVS,
  GET_LOG_CHANELS,
  GET_LAYOUTS,
  GET_MD_UPDATES,
  GET_PROMOCIONES_DASHBOARD,
} from "../../../apollo/queries";
import { GET_GUIA_USO, SIZE_FOLDER } from "../../../apollo/queries/md/index";
import {
  CANAL_ADD,
  CANAL_UPDATE,
  CANAL_DELETE,
  VALIDATE_SCREEN_DISP,
  //CREATE_SCREEN,
  //UPDATE_SCREEN,
  DELETE_SCREEN,
  CHANGE_SCREEN_STATE,
  SEND_MAIL_NEW_SCREEN,
  SCREEN_SHOT_MAKE,
  UPDATE_MD_UPDATES_VISTOS,
  UPDATE_SCREEN_UPDATED,
  CREATE_SCREEN_UPDATED,
} from "../../../apollo/mutations";
import { SCREEN_SHOT_SUB } from "@/apollo/subscriptions";
import { GET_VERSIONES_OPCIONES } from "@/apollo/queries/md/dispositivos";
export default {
  namespaced: true,
  state: {
    newSreen: {},
    CantidadPantallasAdmin: {
      pantallas_contrato: "0",
      registradas: "0",
      no_registradas: "0",
      offline: "0",
      online: "0",
    },
    versiones: [],
    GetTimezones: [],
    GetPantallaList: [],
    listCanales: [],
    GetEstadoCanalesFiltro: [
      {
        id_estado: 5,
        nombre_estado: "Todos",
      },
    ],
    reduceLayouts: {},
    logsIds: {},
    logs: {},
    layouts: [],
    pantallaScreenshot: window.localStorage.getItem("pantallaScreenshot")
      ? JSON.parse(window.localStorage.getItem("pantallaScreenshot"))
      : {},
    pantallaScreenshotLoading: false,
    GuiaUso: JSON.parse(window.localStorage.getItem("GetGuiaUso")) || {},
    Almacenamiento:
      JSON.parse(window.localStorage.getItem("GetAlmacenamiento")) || {},
    Updates: JSON.parse(window.localStorage.getItem("GetUpdates")) || [],
    selectedUpdate: null,
    promociones: [],
  },
  getters: {
    getScreenById: (state) => (id) => {
      const { GetPantallaList } = state;
      const screen = GetPantallaList.find((screen) => screen.id_pantalla == id);
      return screen;
    },
    getChannelById: (state) => async (id) => {
      const { listCanales } = state;
      const channel = listCanales.find((channel) => {
        return channel.id_canal == id;
      });
      return channel;
    },
    getNumLogsByType: (state) => (tipo) => {
      const list = state.logsIds[tipo];
      if (list === undefined || list === null) return 0;
      return list.reduce((a, b) => a + b.ids.length, 0);
    },
    areThereScreensAvailable(state) {
      const { pantallas_contrato, registradas } = state.CantidadPantallasAdmin;
      return Number(pantallas_contrato) > Number(registradas);
    },
  },
  mutations: {
    setVersionesOpciones(state, versiones) {
      state.versiones = versiones;
    },
    setPantallaScreenshot(state, { id_pantalla, resp }) {
      state.pantallaScreenshot[`${id_pantalla}`] = resp;
      window.localStorage.setItem(
        "pantallaScreenshot",
        JSON.stringify(state.pantallaScreenshot)
      );
    },
    setPantallaScreenshotLoading(state, loadingStatus) {
      state.pantallaScreenshotLoading = loadingStatus;
    },
    setLayouts(state, layouts) {
      layouts = layouts.map((layoutType) => ({
        ...layoutType,
        layouts: layoutType.layouts.map((item) => ({
          ...item,
          id_layout: `${item.id_layout}`,
        })),
      }));
      let time = new Date().getTime().toString();
      window.localStorage.setItem("layouts", JSON.stringify(layouts));
      window.localStorage.setItem("layouts_cache", JSON.stringify(layouts));
      window.localStorage.setItem("layouts_timestamp", time);

      state.layouts = layouts;
      state.reduceLayouts = layouts.reduce((acc, curr) => {
        const mapL = curr.layouts.map((layout) => ({
          ...layout,
          id_tipo: curr.id_tipo,
        }));
        return {
          ...acc,
          ...mapL.reduce((accc, currr) => {
            return { ...accc, [currr.id_layout]: currr };
          }, {}),
        };
      }, {});
    },
    getLogsIds(state, { response, tipo }) {
      state.logsIds[tipo] = response || [];
    },
    getLogs(state, { response, tipo }) {
      state.logs[tipo] = response || [];
    },
    SET_CANALES(state, canales) {
      let finalCanales = canales.filter(
        (x) => x.estado.nombre_estado !== "Eliminado"
      );
      window.localStorage.setItem("canales", JSON.stringify(finalCanales));
      state.listCanales = finalCanales;
    },
    SET_ESTADO_CANALES_FILTRO(state, estados) {
      let finalEstados = estados.filter((x) => x.nombre_estado !== "Eliminado");
      state.GetEstadoCanalesFiltro = finalEstados;
      // el estado "Todos" en el top
      state.GetEstadoCanalesFiltro.sort((a, b) =>
        a.id_estado === 5 ? -1 : b.id_estado === 5 ? 1 : 0
      );
    },
    SET_NEW_CANAL(state, canal) {
      state.listCanales.unshift(canal);
    },
    editCanalList(state, canal) {
      let canal_index = state.listCanales.findIndex(
        (canal_) => canal_.id_canal == canal.id_canal
      );
      if (canal_index != undefined) {
        if (state.listCanales.length > 0)
          Object.assign(state.listCanales[canal_index], canal);
      }
    },
    deleteCanalLista(state, data) {
      let found_index = state.listCanales.findIndex(
        (canal) => canal.id_canal == data.id_canal
      );
      state.listCanales.splice(found_index, 1);
    },
    setPantallas(state, resp) {
      state.GetPantallaList = resp;
    },
    setPantallaOne(state, resp) {
      state.newSreen = resp;
    },
    setTimezonesOptions(state, resp) {
      if (state.GetTimezones.length < 1) {
        state.GetTimezones = resp;
      }
    },
    setCantidadPantallas(state, resp) {
      if (parseInt(state.CantidadPantallasAdmin.registradas) < 1) {
        state.CantidadPantallasAdmin = resp;
      }
    },
    setNewScreen(state, resp) {
      state.CantidadPantallasAdmin.registradas =
        parseInt(state.CantidadPantallasAdmin.registradas) + 1;
      state.GetPantallaList.push(resp);
      state.GetPantallaList.sort(
        (a, b) => parseInt(b.id_pantalla) - parseInt(a.id_pantalla)
      );
    },
    setUpdateScreen(state, resp) {
      let index = state.GetPantallaList.findIndex(
        (screen) => parseInt(screen.id_pantalla) == parseInt(resp.id_pantalla)
      );
      if (index > -1) {
        if (state.GetPantallaList.length > 0)
          Object.assign(state.GetPantallaList[index], resp);
      }
    },
    setPromociones(state, promociones) {
      state.promociones = promociones;
    },
    setDeleteScreen(state, resp) {
      let found_index = state.GetPantallaList.findIndex(
        (screen) => screen.id_pantalla == resp.id_pantalla
      );
      state.CantidadPantallasAdmin.registradas =
        parseInt(state.CantidadPantallasAdmin.registradas) - 1;
      state.GetPantallaList.splice(found_index, 1);
    },
    setGuiaUso(state, resp) {
      state.GuiaUso = resp;
      window.localStorage.setItem("GuiaUso", JSON.stringify(resp));
    },
    setAlmacenamiento(state, resp) {
      state.Almacenamiento = resp;
      window.localStorage.setItem("Almacenamiento", JSON.stringify(resp));
    },
    setUpdates(state, resp) {
      state.Updates = resp;
      window.localStorage.setItem("GetUpdates", JSON.stringify(resp));
    },
    setSelectedUpdate(state, update) {
      state.selectedUpdate = update;
    },
    updateVistoActualizacion(state, { id_actualizacion, confirm_visto }) {
      const updateIndex = state.Updates.findIndex(
        (update) => update.id_actualizacion === id_actualizacion
      );
      if (updateIndex !== -1) {
        state.Updates[updateIndex].confirm_visto = confirm_visto;
        window.localStorage.setItem(
          "GetUpdates",
          JSON.stringify(state.Updates)
        );
      }
    },
  },
  actions: {
    /**
     * Envía email para nuevas pantallas
     * @returns {Promise<any>} Resultado de la operación
     */
    async sendMailNewScreen() {
      const params = {
        mutation: SEND_MAIL_NEW_SCREEN,
        variables: {},
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.SendMailNuevasPantallas;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    /**
     * Obtiene los IDs de logs según tipo
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} _data - Datos del filtro
     * @param {String} _data.tipo - Tipo de log a obtener
     * @returns {Promise<Array>} Array de IDs de logs
     */
    async getLogsIds({ commit }, _data) {
      const params = {
        query: GET_LOG_TVS_PAGINATION,
        fetchPolicy: "network-only",
        variables: _data,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.PaginacionLogsCanalPantallas;

        commit("getLogsIds", { response, tipo: _data.tipo });
      } catch (e) {
        console.error("Falla getLogsIds:", e);
        // Aunque falle hay que dejar la clave creada: getLogs lee
        // state.logsIds[tipo] y sin esto se cae con "undefined.length".
        commit("getLogsIds", { response: [], tipo: _data.tipo });
      }
      return response;
    },

    /**
     * Obtiene los logs según tipo y página
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} _data - Datos del filtro
     * @param {String} _data.tipo - Tipo de log
     * @param {Number} _data.page - Número de página
     * @returns {Promise<Array>} Array de logs
     */
    async getLogs({ commit, state }, _data) {
      // Puede no existir la clave si getLogsIds falló, y puede no haber página
      // si se pide una fuera de rango: en ambos casos, lista vacía y no romper.
      const paginas = state.logsIds[_data.tipo];
      if (!Array.isArray(paginas) || paginas.length === 0) {
        commit("getLogs", { response: [], tipo: _data.tipo });
        return [];
      }
      const data_ = paginas.find((x) => x.pagina == _data.page);
      if (!data_) {
        commit("getLogs", { response: [], tipo: _data.tipo });
        return [];
      }
      const params = {
        query: _data.tipo === "pantalla" ? GET_LOG_TVS : GET_LOG_CHANELS,
        variables: { ids: data_.ids },
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading)
          response =
            _data.tipo === "pantalla"
              ? res.data.InformacionLogsPantallas
              : res.data.InformacionLogsCanales;
        commit("getLogs", { response, tipo: _data.tipo });
      } catch (e) {
        console.error("Falla getLogs:", e);
        // Igual que arriba: el componente hace logs[tipo].map(), así que la
        // clave tiene que quedar con un array aunque la consulta falle.
        commit("getLogs", { response: [], tipo: _data.tipo });
      }
      return response;
    },

    async getPaletaColoresAction(_, data_) {
      const params = {
        query: GET_PALETA_COLORES,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetPaletaColores;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async getLayouts({ commit }) {
      let response = null;
      try {
        // Check if data exists in localStorage and if it was fetched less than 5 minutes ago
        const cachedData = localStorage.getItem("layouts_cache");
        const cachedTimestamp = localStorage.getItem("layouts_timestamp");
        const currentTime = new Date().getTime();
        const fiveMinutesInMs = 60 * 60 * 1000;

        // Use cached data if it exists and is less than 60 minutes old
        if (
          cachedData &&
          cachedTimestamp &&
          currentTime - parseInt(cachedTimestamp) < fiveMinutesInMs
        ) {
          response = JSON.parse(cachedData);
        } else {
          // Fetch new data if no cache or cache is older than 5 minutes
          response = await exQue(GET_LAYOUTS, {});

          // Store the fresh data in cache with timestamp
          localStorage.setItem("layouts_cache", JSON.stringify(response));
          localStorage.setItem("layouts_timestamp", currentTime.toString());
        }
        commit("setLayouts", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async getEstadoCanales({ commit }) {
      let params = {
        query: GET_ESTADO_CANALES,
      };
      let response = [];
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.EstadoCanales;
        commit("SET_ESTADO_CANALES_FILTRO", response);
      } catch (e) {
        console.error(e);
      }
    },
    /**
     * Agrega un nuevo canal
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Datos del canal
     * @param {String} data_.nombre_canal - Nombre del canal
     * @param {String} data_.descripcion_canal - Descripción del canal
     * @param {Array<Number>} data_.dias_frecuencia - Array de días de frecuencia
     * @param {String} data_.hora_inicio - Hora de inicio (opcional)
     * @param {String} data_.hora_fin - Hora de fin (opcional)
     * @returns {Promise<Object>} El canal creado
     */
    async addCanal({ commit }, data_) {
      const params = {
        mutation: CANAL_ADD,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.SaveCanal;
        commit("SET_NEW_CANAL", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    /**
     * Actualiza un canal existente
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Datos del canal
     * @param {Number} data_.id_canal - ID del canal a actualizar
     * @param {String} data_.nombre_canal - Nombre del canal
     * @param {String} data_.descripcion_canal - Descripción del canal
     * @param {Array<Number>} data_.dias_frecuencia - Array de días de frecuencia
     * @param {String} data_.hora_inicio - Hora de inicio (opcional)
     * @param {String} data_.hora_fin - Hora de fin (opcional)
     * @returns {Promise<Object>} El canal actualizado
     */
    async editCanal({ commit }, data_) {
      let params = {
        mutation: CANAL_UPDATE,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.UpdateCanal;
        commit("editCanalList", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async deleteCanal({ commit }, data_) {
      const params = {
        mutation: CANAL_DELETE,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.DeleteCanal;
        commit("deleteCanalLista", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async makeScreenShot({ commit }, { id_canal, id_pantalla }) {
      commit("setPantallaScreenshotLoading", true);
      const make = await exMut(SCREEN_SHOT_MAKE, {
        id_canal,
        id_pantalla,
      });

      if (make) {
        const { tipo_dispositivo, identificador_unico } = make;
        const payload = {
          query: SCREEN_SHOT_SUB,
          variables: {
            id_canal,
            id_pantalla,
            tipo_dispositivo,
            identificador_unico,
          },
        };

        const observable = apolloClient.subscribe(payload);
        let sub;
        sub = observable.subscribe({
          next(data) {
            if (data.data.SuscripcionCaptura) {
              if (data.data.SuscripcionCaptura.url_captura !== "") {
                commit("setPantallaScreenshot", {
                  id_pantalla,
                  resp: data.data.SuscripcionCaptura,
                });
                commit("setPantallaScreenshotLoading", false);
                if (sub) {
                  sub.unsubscribe();
                }
              }
            }
          },
          error(err) {
            console.error("Error en la suscripción:", err);
            commit("setPantallaScreenshotLoading", false);
            if (sub) {
              sub.unsubscribe();
            }
          },
          complete() {
            // Ensure loading is false if subscription completes before url_captura is received or if it's an unexpected completion
            commit("setPantallaScreenshotLoading", false);
            if (sub) {
              sub.unsubscribe();
            }
          },
        });
      } else {
        // If 'make' fails (e.g., SCREEN_SHOT_MAKE mutation fails)
        commit("setPantallaScreenshotLoading", false);
      }
    },

    async GetPantallaListAction({ commit }) {
      let response = [];
      let params = {
        query: GET_LIST_SCREENS,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.GetPantallaListUpdated;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("setPantallas", response);
        } else {
          resolve(null);
        }
      });
    },

    async GetOnePantallaAction({ commit }, data_) {
      let response = [];
      let params = {
        query: GET_SCREEN,
        variables: data_,
        fetchPolicy: "network-only",
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) response = res.data.GetPantallaOneUpdated;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("setPantallaOne", response);
        } else {
          resolve(null);
        }
      });
    },

    async GetCantidadPantallasAction({ commit }) {
      const params = {
        query: GET_SCREENS_REGISTERED,
        fetchPolicy: "network-only",
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.CantidadPantallasAdmin;
        commit("setCantidadPantallas", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async GetCantidadPantallasPaginadasAction(_, data_) {
      const params = {
        query: GET_PANTALLAS_PAGINADAS,
        variables: data_,
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.PantallasPaginadasUpdated;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async GetGuia({ commit }) {
      const params = {
        query: GET_GUIA_USO,
        variables: {},
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetGuiaUsoModulo;
        commit("setGuiaUso", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    async GetAlmacenamiento({ commit }) {
      const params = {
        query: SIZE_FOLDER,
        variables: {},
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.CheckSizeFolder;
        commit("setAlmacenamiento", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    /**
     * Obtiene las actualizaciones del módulo
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} params - Parámetros de la consulta
     * @param {Number} params.id_modulo - ID del módulo
     * @param {Number} params.id_tipo - ID del tipo de actualización
     * @returns {Promise<Array>} Lista de actualizaciones
     */
    async GetUpdates({ commit }, { id_modulo = 24, id_tipo = 1 }) {
      const params = {
        query: GET_MD_UPDATES,
        variables: { id_modulo, id_tipo },
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetActualizaciones;
        if (id_tipo == 1) commit("setUpdates", response);
        if (id_tipo == 2) commit("setPromociones", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async GetPromociones({ commit }) {
      const params = {
        query: GET_PROMOCIONES_DASHBOARD,
        variables: {
          id_modulo: 24,
        },
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetPromocionesDashboard;
        commit("setPromociones", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    /**
     * Marca una actualización como vista
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} params - Parámetros de la mutación
     * @param {Number} params.id_actualizacion - ID de la actualización
     * @param {Number} params.id_modulo - ID del módulo
     * @param {Number} params.id_tipo - ID del tipo de actualización
     * @returns {Promise<Object>} Resultado de la mutación
     */
    async MarkUpdateAsViewed(
      { commit },
      { id_actualizacion, id_modulo = 24, id_tipo = 1 }
    ) {
      const params = {
        mutation: UPDATE_MD_UPDATES_VISTOS,
        variables: { id_actualizacion, id_modulo, id_tipo },
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (res.data) {
          response = res.data.UpdateVistoActualizacion;
          commit("updateVistoActualizacion", {
            id_actualizacion,
            confirm_visto: response.confirm_visto,
          });
        }
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async GetCantidadPantallasOnOffAction(_, data_) {
      const params = {
        query: GET_TOTAL_PANTALLAS_ONOFF,
        variables: data_,
      };

      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.TotalPantallasOnOff;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    /**
     * Obtiene el listado de canales
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Filtros para obtener canales
     * @returns {Promise<Array>} Lista de canales
     */
    async GetListCanalesAction({ commit }, data_) {
      const params = {
        query: GET_CANALES,
        variables: data_,
        fetchPolicy: "network-only",
      };
      if (window.localStorage.getItem("canales") != null) {
        commit(
          "SET_CANALES",
          JSON.parse(window.localStorage.getItem("canales"))
        );
      }
      let response = null;
      try {
        const res = await apolloClient.query(params);
        if (!res.loading) response = res.data.GetListCanales;
        commit("SET_CANALES", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async GetTimezonesActions({ commit }) {
      let response = {};
      let data = {};
      let params = {
        query: GET_TIMEZONES,
      };
      try {
        await apolloClient.query(params).then((res) => {
          if (!res.loading) data = res.data.GetZonasHorarias;
          response = data;
        });
      } catch (e) {
        console.error(e);
        response = null;
      }
      return new Promise((resolve) => {
        if (response != null) {
          resolve(response);
          commit("setTimezonesOptions", response);
        } else {
          resolve(null);
        }
      });
    },
    /**
     * Guarda una nueva pantalla
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Datos de la pantalla
     * @param {String} data_.nombre_pantalla - Nombre de la pantalla
     * @param {String} data_.descripcion_pantalla - Descripción de la pantalla
     * @param {String} data_.codigo - Código único de la pantalla
     * @param {String} data_.ubicacion - Ubicación física de la pantalla
     * @param {String} data_.zona_horaria - Zona horaria de la pantalla
     * @param {Array<Number>} data_.id_canal - Array de IDs de canales asociados
     * @param {Number} data_.id_dispositivo - ID del dispositivo asociado
     * @returns {Promise<Object>} La pantalla creada
     */
    async SaveScreenAction({ commit }, variables) {
      const params = {
        mutation: CREATE_SCREEN_UPDATED,
        variables,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.SavePantallaUpdated;
        commit("setNewScreen", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },
    /**
     * Actualiza una pantalla existente
     * @param {ActionContext} context - El contexto de Vuex
     * @param {Object} data_ - Datos de la pantalla
     * @param {String} data_.nombre_pantalla - Nombre de la pantalla
     * @param {String} data_.descripcion_pantalla - Descripción de la pantalla
     * @param {String} data_.codigo - Código único de la pantalla
     * @param {String} data_.ubicacion - Ubicación física de la pantalla
     * @param {String} data_.zona_horaria - Zona horaria de la pantalla
     * @param {Array<Number>} data_.id_canal - Array de IDs de canales asociados
     * @param {Number} data_.id_pantalla - ID de la pantalla a actualizar
     * @returns {Promise<Object>} La pantalla actualizada
     */
    async UpdateScreenAction({ commit }, variables) {
      const params = {
        mutation: UPDATE_SCREEN_UPDATED,
        variables,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);

        if (!res.loading) response = res.data.UpdatePantallaUpdated;
        commit("setUpdateScreen", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async DeleteScreenAction({ commit }, data_) {
      const params = {
        mutation: DELETE_SCREEN,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.DeletePantalla;
        commit("setDeleteScreen", response);
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async ValidateScreenDispAction(_, data_) {
      let params = {
        mutation: VALIDATE_SCREEN_DISP,
        variables: data_,
      };

      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.ValidarDispositivo;
      } catch (e) {
        console.error(e);
      }
      return response;
    },

    async GetVersionesOpciones({ commit, state }) {
      if(state.versiones && state.versiones.length === 0){
        const versiones = await exQue(GET_VERSIONES_OPCIONES)
        commit('setVersionesOpciones', versiones)
      }
    },
    async RejectScreenSaving(/* { commit } */ _, data_) {
      const params = {
        mutation: CHANGE_SCREEN_STATE,
        variables: data_,
      };
      let response = null;
      try {
        const res = await apolloClient.mutate(params);
        if (!res.loading) response = res.data.UpdateEstadoDispositivo;
      } catch (e) {
        console.error(e);
      }
      return response;
    },
  },
};
